import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #333;
  color: #fff;
  padding: 1rem;
`;

const NavItem = styled.li`
  list-style: none;
  margin: 0 1rem;

  a {
    color: #fff;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: #bada55;
    }
  }
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  margin: 0;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;

  &:hover {
    color: #bada55;
    text-decoration: none;
  }
`;


const MobileNavToggle = styled.button`
  display: block;
  background-color: transparent;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #bada55;
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

const DesktopNav = styled.ul`
  display: flex;
  flex-direction: row;

  @media (max-width: 767px) {
    display: none;
  }
`;

const MobileNav = styled.ul`
  display: none;
  flex-direction: column;
  margin: 0;
  padding: 0;

  @media (max-width: 767px) {
    display: flex;
  }
`;

const MainContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const ContentArea = styled.main`
  flex: 1;
  padding: 2rem;
  background-color: #f8f9fa;
`;

const Footer = styled.footer`
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 1.5rem;
  margin-top: auto;
  font-size: 0.9rem;
  border-top: 1px solid #555;
`;

const HomePage = ({ children }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = React.useState(false);

  return (
    <MainContainer>
      <Nav>
        <Logo to="/">My Logo</Logo>
        <MobileNavToggle onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}>
          {isMobileNavOpen ? 'Close' : 'Menu'}
        </MobileNavToggle>
        <DesktopNav>
          <NavItem><a href="/nsedetails">NSE</a></NavItem>
          <NavItem><a href="/nsechart">Chart</a></NavItem>
        </DesktopNav>
        <MobileNav style={{ display: isMobileNavOpen ? 'flex' : 'none' }}>
          <NavItem><a href="/nsedetails">NSE</a></NavItem>
          <NavItem><a href="/nsechart">Chart</a></NavItem>
        </MobileNav>
      </Nav>
      <ContentArea>
        {children}
      </ContentArea>
      <Footer>
        Nse HDFC Chart Application Version 7.1. All rights reserved @ Maclogi Systems 2028
      </Footer>
    </MainContainer>
  );
};

export default HomePage;